import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
  /**
   * text filter pipe for search
   */
export class FilterPipe implements PipeTransform {
  // transform(items, searchText: string) {
  //   if (!items) { return []; }
  //   if (!searchText) { return items; }
  //   searchText = searchText.toLowerCase();
  //   return items.filter( it => {
  //     return it.applicationName.toLowerCase().includes(searchText);
  //   });
  //  }

   /**
     * @param items object from array
     * @param term term's search
     * @param excludes array of strings which will ignored during search
     */
    transform(items: any, term: string, excludes: any = []): any {
      if (!term || !items) 
      {
        return items;
      }
  
      return FilterPipe.filter(items, term, excludes);
    }
  
    /**
     *
     * @param items List of items to filter
     * @param term  a string term to compare with every property of the list
     * @param excludes List of keys which will be ignored during search
     *
     */
    static filter(items: Array<{ [key: string]: any }>, term: string, excludes: any): Array<{ [key: string]: any }> {
  
      const toCompare = term.toLowerCase();
  
      function checkInside(item: any, terms) {
        
        if (typeof item === "string" && item.toString().toLowerCase().includes(toCompare)) {
          return true;
        }
  
        for (const property in item) {
          if (item[property] === null || item[property] === undefined || excludes.includes(property)) {
            continue;
          }
          if (typeof item[property] === 'object') {
            if (checkInside(item[property], terms)) {
              return true;
            }
          }
          else if (item[property].toString().toLowerCase().includes(toCompare)) {
            return true;
          } else {
            //Added to sonarQube Fix
          }
        }
        return false;
      }
  
      return items.filter(function (item) {
        return checkInside(item, term);
      });
    }


}
